import React from "react";
import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";

import { App, Router } from "containers";
import { Intl } from "intl";
import { Theme } from "themes";
import {
  CatalogProvider,
  CartProvider,
  FilterProvider,
  VehicleProvider,
  CheckoutProvider,
  CookieProvider,
  ConfigurationProvider,
} from "stores";

import reportWebVitals from "./reportWebVitals";

const container = document.getElementById("carbando-root");
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <ConfigurationProvider>
      <Theme>
        <Router>
          <CookieProvider config={{ type: "prod" }}>
            <CatalogProvider config={{ type: "prod" }}>
              <CartProvider config={{ type: "prod" }}>
                <CheckoutProvider config={{ type: "prod" }}>
                  <FilterProvider config={{ type: "prod" }}>
                    <VehicleProvider>
                      <HelmetProvider>
                        <Intl>
                          <App />
                        </Intl>
                      </HelmetProvider>
                    </VehicleProvider>
                  </FilterProvider>
                </CheckoutProvider>
              </CartProvider>
            </CatalogProvider>
          </CookieProvider>
        </Router>
      </Theme>
    </ConfigurationProvider>
  </React.StrictMode>
);

reportWebVitals();
